import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import '@/index.css';
import App from '@/App';
import { Toaster } from 'sonner';
import { registerServiceWorker } from '@/lib/pwa';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster position="top-center" richColors closeButton />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Register the service worker after render so it never blocks first paint.
// Fire-and-forget: a failure here just means offline support is disabled;
// the app still works fully online.
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
  window.requestIdleCallback(() => registerServiceWorker());
} else {
  setTimeout(() => registerServiceWorker(), 1500);
}
